import {
  SAVE_PAYOUT_ACCOUNT,
  SAVE_PAYOUT_ACCOUNT_SUCCESS,
  SAVE_PAYOUT_ACCOUNT_FAILURE,
  PAYOUT_ACCOUNT,
  PAYOUT_ACCOUNT_SUCCESS,
  PAYOUT_ACCOUNT_FAILURE,
  MANUAL_PAYMENT,
  MANUAL_PAYMENT_SUCCESS,
  MANUAL_PAYMENT_FAILURE,
  CARD_PAYMENT,
  CARD_PAYMENT_SUCCESS,
  CARD_PAYMENT_FAILURE,
  OTHER_PAYMENT,
  OTHER_PAYMENT_SUCCESS,
  OTHER_PAYMENT_FAILURE,
  RESET_PAYOUT,
  PayoutState,
  PayoutTypes,
} from "../types/payoutType";

const initialState: PayoutState = {
  savePayoutAccountSuccess: null,
  savePayoutAccountError: null,
  savePayoutAccountLoading: false,

  payoutAccountSuccess: null,
  payoutAccountError: null,
  payoutAccountLoading: false,
  payoutAccountList: [],
  savedData: {},

  cardPaymentSuccess: null,
  cardPaymentError: null,
  cardPaymentLoading: false,

  manualPaymentSuccess: null,
  manualPaymentError: null,
  manualPaymentLoading: false,

  otherPaymentSuccess: null,
  otherPaymentError: null,
  otherPaymentLoading: false,
};

export const payoutReducer = (
  state = initialState,
  action: PayoutTypes
): PayoutState => {
  switch (action.type) {
    case SAVE_PAYOUT_ACCOUNT: {
      return {
        ...state,
        payoutAccountList: [],
        savePayoutAccountError: null,
        savePayoutAccountLoading: true,
      };
    }

    case SAVE_PAYOUT_ACCOUNT_SUCCESS: {
      return {
        ...state,
        payoutAccountList: state.payoutAccountList,
        savedData: action.payload?.data,
        savePayoutAccountSuccess: action.payload?.message,
        savePayoutAccountError: null,
        savePayoutAccountLoading: false,
      };
    }

    case SAVE_PAYOUT_ACCOUNT_FAILURE: {
      return {
        ...state,
        savePayoutAccountError: action.payload,
        savePayoutAccountLoading: false,
      };
    }

    case PAYOUT_ACCOUNT:
      return {
        ...state,
        payoutAccountLoading: true,
        payoutAccountList: [],
        payoutAccountError: null,
      };

    case PAYOUT_ACCOUNT_SUCCESS: {
      return {
        ...state,
        payoutAccountLoading: false,
        payoutAccountList: action.payload.data || [],
        payoutAccountError: null,
      };
    }

    case PAYOUT_ACCOUNT_FAILURE:
      return {
        ...state,
        payoutAccountLoading: false,
        payoutAccountError: action.payload,
      };

    case CARD_PAYMENT:
      return { ...state, cardPaymentLoading: true, cardPaymentError: null };

    case CARD_PAYMENT_SUCCESS: {
      return {
        ...state,
        cardPaymentSuccess: action.payload?.message,
        cardPaymentLoading: false,
        cardPaymentError: null,
      };
    }

    case CARD_PAYMENT_FAILURE:
      return {
        ...state,
        cardPaymentLoading: false,
        cardPaymentError: action.payload,
      };

    case MANUAL_PAYMENT:
      return { ...state, manualPaymentLoading: true, manualPaymentError: null };

    case MANUAL_PAYMENT_SUCCESS: {
      return {
        ...state,
        manualPaymentSuccess: action.payload?.message,
        manualPaymentLoading: false,
        manualPaymentError: null,
      };
    }

    case MANUAL_PAYMENT_FAILURE:
      return {
        ...state,
        manualPaymentLoading: false,
        manualPaymentError: action.payload,
      };

    case OTHER_PAYMENT:
      return { ...state, otherPaymentLoading: true, otherPaymentError: null };

    case OTHER_PAYMENT_SUCCESS: {
      return {
        ...state,
        otherPaymentSuccess: action.payload?.message,
        otherPaymentLoading: false,
        otherPaymentError: null,
      };
    }

    case OTHER_PAYMENT_FAILURE:
      return {
        ...state,
        otherPaymentLoading: false,
        otherPaymentError: action.payload,
      };

    case RESET_PAYOUT: {
      return {
        ...state,
        cardPaymentSuccess: null,
        otherPaymentSuccess: null,
        manualPaymentSuccess: null,
        savedData: null,
        payoutAccountSuccess: null,
        payoutAccountError: null,
        payoutAccountLoading: false,
      };
    }

    default:
      return state;
  }
};
